/* shop-hyper.js — wires the ported shop page (filters/sort/quick-view/toast) + REAL /cart/add.js.
   GENERATED by shop-hyper-gen/gen-shop.cjs from localhost:5700 shop-10.html. Loaded shop-gated, deferred,
   AFTER cro.js (which exposes window.__croRefreshCart). Does NOT touch the chrome (home-hyper.js owns that). */

(function(){
  "use strict";

  // ---- Australian flag SVG (lifted verbatim from the suite's cart.js AUS_FLAG) ----
  var AUS_FLAG = '';
  ['shHeroFlag','shTrustFlag','shFooterFlag'].forEach(function(id){
    var el = document.getElementById(id);
    if (el) el.insertAdjacentHTML('afterbegin', AUS_FLAG + ' ');
  });

  // ---- data: the 6 real products (real titles, AUD now/was, exact live CDN images) ----
  var money = function(n){ return '$' + n.toFixed(2); };
  var PRODUCTS = [
    { id:'full',   title:'Hard-Bottom Car Seat Cover', handle:'full-seat-cover',
      now:239.90, was:239.90, cat:'covers', pop:5,
      img:'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-full-seat-cover.webp?v=1793250490',
      tags:[{t:'Best seller',c:'bestseller'}], desc:'Firm hard base, wipe-clean cover — flat, no sag, no slip.',
      feats:['Rigid hard base stays flat — no hammock sag','Wipe-clean, waterproof top layer','Covers the whole back seat + protects the doors'] },
    { id:'single', title:'Hard-Bottom Single Seat Cover', handle:'single-seat-cover',
      now:219.90, was:219.90, cat:'covers', pop:3,
      img:'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-single-seat-cover.webp?v=1793250493',
      tags:[], desc:'The hard-base protection, sized for a single seat.',
      feats:['Same firm hard base, single-seat fit','Wipe-clean and waterproof','Perfect for one dog + a free passenger seat'] },
    { id:'bed',    title:'Plush Custom-Fit Travel Bed', handle:'travel-bed',
      now:199.90, was:199.90, cat:'beds', pop:4,
      img:'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-travel-bed.webp?v=1793250496',
      tags:[], desc:'A snug, custom-fit bed that calms the ride.',
      feats:['Plush, custom-fit shape settles your dog fast','Removable, washable cover','Pairs with the seat cover for a full setup'] },
    { id:'steady', title:'SteadyRide Travel System', handle:'steady-ride-system',
      now:319.90, was:319.90, cat:'bundle', pop:6, bundle:true,
      img:'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/swap-petride-steady-ride-system-2-v2.webp?v=1784204146',
      tags:[{t:'Bundle',c:'bundle'}], desc:'Cover + bed as one clean, comfy travel setup.',
      feats:['Hard-bottom seat cover + plush travel bed','Seat cover and bed, made to travel together','The complete clean-and-comfy travel setup'] },
    { id:'fount',  title:'Pet Water Fountain', handle:'pet-water-fountain',
      now:259.90, was:259.90, cat:'fountain', pop:3,
      img:'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-pet-water-fountain.webp?v=1793250499',
      tags:[], desc:'Fresh, filtered water for on the go.',
      feats:['Keeps water fresh and moving','Filtered for a cleaner drink','Quiet enough for the car and the home'] },
    { id:'filter', title:'Replacement Filters', handle:'replacement-filters',
      now:49.90, was:49.90, cat:'accessories', pop:2,
      img:'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-replacement-filters-1-v3.png?v=1782969811',
      tags:[{t:'Add-on',c:''}], desc:'Keep the fountain fresh — easy swap-in filters.',
      feats:['Drop-in replacement for the Pet Water Fountain','Keeps water clean and tasting fresh','Easy, tool-free swap'] }
  ];
  // add a computed save% (real math) + attach the REAL Loox ratings/counts from petride.com.au
  // (server-rendered "Rated X out of 5 stars based on N reviews" aria-labels, read 2026-08-14)
  var REV = { full:{r:'4.8',n:600}, single:{r:'4.8',n:493}, bed:{r:'4.9',n:314}, steady:{r:'5.0',n:235}, fount:{r:'4.8',n:600}, filter:{r:'4.8',n:600} };
  PRODUCTS.forEach(function(p){ p.savePct = Math.round((1 - p.now / p.was) * 100); var rv = REV[p.id] || { r:'4.8', n:0 }; p.rating = rv.r; p.reviews = rv.n; });

  var CATS = [
    { key:'all',         label:'All' },
    { key:'covers',      label:'Seat Covers' },
    { key:'beds',        label:'Beds' },
    { key:'bundle',      label:'Bundle' },
    { key:'fountain',    label:'Fountain' },
    { key:'accessories', label:'Accessories' }
  ];

  var state = { cat:'all', sort:'featured' };
  var cart = 0;

  // ---- REAL Shopify add-to-cart (variant ids resolved from live product .js, 2026-08-18) ----
  var VARIANTS = { full:54205963272476, single:54205963305244, bed:54205963239708, steady:54222090764572, fount:54205963370780, filter:54205963403548 };
  function shOpenCart(){
    if (typeof window.__croRefreshCart === 'function'){ try { return Promise.resolve(window.__croRefreshCart(true)); } catch(e){} }
    var cb = document.querySelector('.hm-headacts button[title="Cart"], .cart-drawer-trigger'); if (cb){ cb.click(); return Promise.resolve(); }
    return Promise.resolve();
  }
  // Unified ATC flow: "Adding to cart" + spinner is HELD until the cart drawer actually opens and
  // renders the product, THEN the button flips to "Added \u2713" (green), then reverts to its label.
  function shRealAddItems(items, btn, label){
    return Promise.resolve(); /* 29 Oct 2026: whole store sold out, add to cart switched off */
    if (btn){
      if (btn._revT){ clearTimeout(btn._revT); btn._revT = null; }
      if (!btn.getAttribute('data-orig')){ btn.setAttribute('data-orig', btn.innerHTML); }
      btn.disabled = true; btn.classList.remove('added');
      btn.innerHTML = 'Adding to cart <span class="cc-spin"></span>';
    }
    return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ return shOpenCart(); })
      .then(function(){
        if (btn){ btn.disabled = false; btn.classList.add('added'); btn.innerHTML = 'Added \u2713'; }
        toast('\u2713 Added ' + (label || 'to cart'));
        if (btn){ btn._revT = setTimeout(function(){ btn.classList.remove('added'); btn.innerHTML = btn.getAttribute('data-orig') || 'Add to cart'; btn.removeAttribute('data-orig'); btn._revT = null; }, 2600); }
      })
      .catch(function(){ if (btn){ btn.disabled = false; btn.classList.remove('added'); btn.innerHTML = btn.getAttribute('data-orig') || 'Add to cart'; btn.removeAttribute('data-orig'); } toast('Could not add \u2014 please try again'); });
  }
  function shRealAdd(variantId, qty, btn, label){ return shRealAddItems([{ id: variantId, quantity: qty || 1 }], btn, label); }

  // ---- announcement marquee ----
  var ancItems = [
    '🚚 <b>Free shipping</b> on every Australian order',
    '↩️ <b>60-day</b> money-back guarantee',
    '<span class="sh-anc-ap">afterpay</span> 4 interest-free payments',
    '🐾 Built for dogs who <b>tag along everywhere</b>',
    'Proudly <b>Aussie owned</b>'
  ];
  (function(){
    var track = document.getElementById('shAnc');
    if (!track) return;
    function set(){
      var s = document.createElement('span'); s.className = 'sh-anc-set';
      ancItems.forEach(function(html, i){
        var item = document.createElement('span'); item.className = 'sh-anc-i'; item.innerHTML = html;
        s.appendChild(item);
        var dot = document.createElement('span'); dot.className = 'sh-anc-dot'; s.appendChild(dot);
      });
      return s;
    }
    // two identical sets → seamless -50% marquee loop
    track.appendChild(set()); track.appendChild(set());
  })();

  // ---- render chips ----
  (function(){
    var wrap = document.getElementById('shChips');
    CATS.forEach(function(c){
      var b = document.createElement('button');
      b.className = 'sh-chip' + (c.key === state.cat ? ' is-active' : '');
      b.type = 'button'; b.textContent = c.label; b.setAttribute('role','tab');
      b.onclick = function(){
        state.cat = c.key;
        wrap.querySelectorAll('.sh-chip').forEach(function(x){ x.classList.remove('is-active'); });
        b.classList.add('is-active');
        render();
      };
      wrap.appendChild(b);
    });
  })();

  // ---- card template ----
  function cardHTML(p){
    var tags = (p.tags || []).map(function(t){ return '<span class="sh-tag ' + t.c + '">' + t.t + '</span>'; }).join('');
    
    var ap = (p.now / 4);
    return '' +
      '<article class="sh-card" data-id="' + p.id + '">' +
        '<div class="sh-card-img">' +
          '<div class="sh-card-tags">' + tags + '</div>' +
          '<button class="sh-qv" aria-label="Quick view" data-qv="' + p.id + '">👁️</button>' +
          '<a href="https://petride.com.au/products/' + p.handle + '" target="_blank" rel="noopener" aria-label="' + p.title + '">' +
            '<img src="' + p.img + '" alt="' + p.title + '" loading="lazy">' +
          '</a>' +
        '</div>' +
        '<div class="sh-card-body">' +
          '<div class="sh-card-rate"><span class="stars" aria-hidden="true">★★★★★</span> <b>' + p.rating + '</b> ' +
            '<span class="rc">· ' + p.reviews.toLocaleString() + ' reviews</span></div>' +
          '<b class="sh-card-title">' + p.title + '</b>' +
          '<div class="sh-card-desc">' + p.desc + '</div>' +
          '<div class="sh-card-price">' + money(p.now) + '</div>' +
          '<div class="sh-card-ap">or 4× <b>' + money(ap) + '</b> <span class="sh-ap-logo">afterpay</span></div>' +
          '<div class="sh-card-actions">' +
            '<button class="sh-card-add" data-add="' + p.id + '" disabled aria-disabled="true">Sold out</button>' +
            '<a class="sh-card-view" href="/products/' + p.handle + '">View</a>' +
          '</div>' +
        '</div>' +
      '</article>';
  }

  // ---- render grid ----
  function render(){
    var grid = document.getElementById('shGrid');
    var list = PRODUCTS.filter(function(p){ return state.cat === 'all' || p.cat === state.cat; });
    var s = document.getElementById('shSort'); state.sort = s ? s.value : 'featured';
    list = list.slice();
    if (state.sort === 'low')  list.sort(function(a,b){ return a.now - b.now; });
    if (state.sort === 'high') list.sort(function(a,b){ return b.now - a.now; });
    if (state.sort === 'save') list.sort(function(a,b){ return b.savePct - a.savePct; });
    if (state.sort === 'popular') list.sort(function(a,b){ return b.pop - a.pop; });
    // featured: bundle first, then original order
    if (state.sort === 'featured') list.sort(function(a,b){ return (b.bundle?1:0) - (a.bundle?1:0); });

    grid.innerHTML = list.length ? list.map(cardHTML).join('') :
      '<div class="sh-empty">No products in this category yet.</div>';

    var cnt = document.getElementById('shCount');
    if (cnt) cnt.textContent = list.length + (list.length === 1 ? ' product' : ' products');
  }
  window.shRender = render;
  render();
  var _yr = document.getElementById('shYear'); if (_yr) _yr.textContent = new Date().getFullYear();

  // ---- event delegation: add-to-cart + quick-view (grid) ----
  document.getElementById('shGrid').addEventListener('click', function(e){
    var add = e.target.closest('[data-add]');
    if (add){ shAddById(add.getAttribute('data-add'), add); return; }
    var qv = e.target.closest('[data-qv]');
    if (qv){ openModal(qv.getAttribute('data-qv')); }
  });

  function byId(id){ return PRODUCTS.filter(function(p){ return p.id === id; })[0]; }

  function bumpCart(n, label){
    cart += n;
    toast('✓ Added ' + (label || 'to cart'));
  }

  function shAddById(id, btn){
    var p = byId(id); if (!p) return;
    shRealAdd(VARIANTS[id], 1, btn, p.title);
  }

  // bundle + pair adds (called from inline onclick)
  window.shAdd = function(kind, btn){
    if (kind === 'steady'){ shRealAdd(VARIANTS.steady, 1, btn, 'SteadyRide Travel System'); }
    else if (kind === 'pair'){ shRealAddItems([{ id: VARIANTS.fount, quantity: 1 }, { id: VARIANTS.filter, quantity: 1 }], btn, 'Fountain + Filters'); }
  };

  // ---- quick-view modal ----
  var modal = document.getElementById('shModal');
  function openModal(id){
    var p = byId(id); if (!p) return;
    document.getElementById('shModalImg').src = p.img;
    document.getElementById('shModalImg').alt = p.title;
    document.getElementById('shModalTitle').textContent = p.title;
    document.getElementById('shModalRate').innerHTML = '<span class="stars" aria-hidden="true">★★★★★</span> <b>' + p.rating + '</b> · ' + p.reviews.toLocaleString() + ' reviews';
    document.getElementById('shModalPrice').innerHTML =
      '<span class="now">' + money(p.now) + '</span>';
    document.getElementById('shModalAp').innerHTML =
      'or 4 interest-free payments of <b>' + money(p.now/4) + '</b> with <span class="sh-ap-logo">afterpay</span>';
    document.getElementById('shModalDesc').textContent = p.desc;
    document.getElementById('shModalFeats').innerHTML =
      p.feats.map(function(f){ return '<li>' + f + '</li>'; }).join('');
    var add = document.getElementById('shModalAdd');
    add.textContent = 'Sold out'; add.disabled = true;
    add.classList.remove('added');
    add.onclick = null;
    document.getElementById('shModalLink').href = 'https://petride.com.au/products/' + p.handle;
    modal.classList.add('is-open');
  }
  window.shCloseModal = function(){ modal.classList.remove('is-open'); };
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){ shCloseModal(); shMobClose(); shSearchClose(); }
  });

  // ---- header search (live filter of the 6 products) ----
  var searchOpen = false;
  window.shSearchToggle = function(){
    var sd = document.getElementById('shSearch'); if (!sd) return;
    searchOpen = !searchOpen;
    sd.classList.toggle('is-open', searchOpen);
    if (searchOpen){ setTimeout(function(){ var si = document.getElementById('shSearchInput'); if (si) si.focus(); }, 60); shSearch(''); }
  };
  function shSearchClose(){ searchOpen = false; var sd = document.getElementById('shSearch'); if (sd) sd.classList.remove('is-open'); }
  window.shSearch = function(q){
    var res = document.getElementById('shSearchResults'); if (!res) return;
    q = (q || '').trim().toLowerCase();
    var list = PRODUCTS.filter(function(p){ return !q || p.title.toLowerCase().indexOf(q) > -1 || p.cat.indexOf(q) > -1; });
    if (!list.length){ res.innerHTML = '<div class="sh-sr-empty">No matches. Try “cover”, “bed” or “fountain”.</div>'; return; }
    res.innerHTML = list.map(function(p){
      return '<a class="sh-sr" href="https://petride.com.au/products/' + p.handle + '" target="_blank" rel="noopener">' +
        '<img src="' + p.img + '" alt="">' +
        '<div><b>' + p.title + '</b>' +
        '<div class="sh-sr-p"><em>' + money(p.now) + '</em></div></div></a>';
    }).join('');
  };
  document.addEventListener('click', function(e){
    if (searchOpen && !e.target.closest('#shSearch') && !e.target.closest('[data-search]')) shSearchClose();
  });

  // ---- mobile menu ----
  window.shMob = function(open){ var m = document.getElementById('shMob'); if (m) m.classList.toggle('is-open', open); };
  function shMobClose(){ var m = document.getElementById('shMob'); if (m) m.classList.remove('is-open'); }

  // ---- newsletter ----
  window.shSubscribe = function(e){
    e.preventDefault();
    document.getElementById('shCapture').classList.add('is-done');
    toast('✓ You’re on the list');
    return false;
  };

  // ---- smooth scroll helpers ----
  window.shScrollTo = function(sel){
    var el = document.querySelector(sel);
    if (el) el.scrollIntoView({ behavior:'smooth', block:'start' });
  };

  // ---- free-shipping bar (always free in AU — fill once cart has anything) ----
  // Honest: shipping is free on ALL AU orders. The bar is a friendly reinforcement, not a spend threshold.
  function updateFsBar(){
    var fill = document.getElementById('shFsFill');
    var txt = document.getElementById('shFsTxt');
    if (!fill || !txt) return;   // free-ship bar removed from the simplified hero
    if (cart > 0){
      fill.style.width = '100%';
      txt.innerHTML = '<b>Free shipping unlocked 🎉</b><span>Every AU order ships free — you\'re all set.</span>';
    } else {
      fill.style.width = '18%';
      txt.innerHTML = '<b>Free shipping on every AU order</b><span>Add anything to your cart — Australian delivery is on us.</span>';
    }
  }
  updateFsBar();
  // hook cart bumps to the shipping bar
  var _bump = bumpCart;
  bumpCart = function(n,l){ _bump(n,l); updateFsBar(); };

  // ---- toast ----
  var toastTimer;
  function toast(msg){
    var t = document.getElementById('shToast');
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('is-show'); }, 1900);
  }

})();


/* ---- keep the sticky filter bar pinned below the live glass header (--cc-chrome-h) ---- */
(function(){
  function shSyncChromeH(){ var h = document.querySelector('.cc-chrome-top'); var px = h ? Math.round(h.getBoundingClientRect().height) : 64; document.documentElement.style.setProperty('--cc-chrome-h', px + 'px'); }
  if (document.readyState !== 'loading') shSyncChromeH(); else document.addEventListener('DOMContentLoaded', shSyncChromeH);
  window.addEventListener('resize', shSyncChromeH); window.addEventListener('load', shSyncChromeH); setTimeout(shSyncChromeH, 900);
})();